// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as CustomPaymentMethodsConfig$OrcaPaymentPage from "../Hooks/CustomPaymentMethodsConfig.bs.js";

function Terms(props) {
  var paymentMethodType = props.paymentMethodType;
  var paymentMethod = props.paymentMethod;
  var __styles = props.styles;
  var styles = __styles !== undefined ? __styles : ({});
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var customMessageForCardTerms = match$1.customMessageForCardTerms;
  var terms = match$1.terms;
  var business = match$1.business;
  var match$2 = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var cardTermsValue = customMessageForCardTerms !== "" ? customMessageForCardTerms : localeString.cardTerms(business.name);
  var paymentMethodTermsDefaults;
  switch (paymentMethod) {
    case "bank_debit" :
        switch (paymentMethodType) {
          case "ach" :
              paymentMethodTermsDefaults = [
                localeString.achBankDebitTerms(business.name),
                terms.usBankAccount
              ];
              break;
          case "becs" :
              paymentMethodTermsDefaults = [
                localeString.becsDebitTerms,
                terms.auBecsDebit
              ];
              break;
          case "sepa" :
              paymentMethodTermsDefaults = [
                localeString.sepaDebitTerms(business.name),
                terms.sepaDebit
              ];
              break;
          default:
            paymentMethodTermsDefaults = [
              "",
              "Never"
            ];
        }
        break;
    case "card" :
        switch (match$2.payment_type) {
          case "NEW_MANDATE" :
          case "SETUP_MANDATE" :
              paymentMethodTermsDefaults = [
                cardTermsValue,
                terms.card
              ];
              break;
          case "NORMAL" :
          case "NONE" :
              paymentMethodTermsDefaults = [
                "",
                "Never"
              ];
              break;
          
        }
        break;
    default:
      paymentMethodTermsDefaults = [
        "",
        "Never"
      ];
  }
  var customConfig = CustomPaymentMethodsConfig$OrcaPaymentPage.useCustomPaymentMethodConfigs(paymentMethod, paymentMethodType);
  var customMessageConfig = Core__Option.getOr(Core__Option.map(customConfig, (function (config) {
              return config.message;
            })), PaymentType$OrcaPaymentPage.defaultPaymentMethodMessage);
  var match$3 = customMessageConfig.displayMode;
  var match$4;
  switch (match$3) {
    case "DefaultSdkMessage" :
        match$4 = paymentMethodTermsDefaults;
        break;
    case "CustomMessage" :
        var customMessage = Core__Option.getOr(customMessageConfig.value, "").trim();
        match$4 = [
          customMessage,
          customMessage.length > 0 ? "Always" : "Never"
        ];
        break;
    case "Hidden" :
        match$4 = [
          "",
          "Never"
        ];
        break;
    
  }
  var showTerm = match$4[1];
  var newrecord = Caml_obj.obj_dup(styles);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: showTerm === "Auto" || showTerm === "Always",
              children: React.createElement("div", {
                    className: "TermsTextLabel opacity-50 text-xs mb-2 text-left",
                    style: (newrecord.color = match.themeObj.colorText, newrecord)
                  }, match$4[0])
            });
}

var make = Terms;

export {
  make ,
}
/* react Not a pure module */
